import * as o from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/TagChevron.es.js";
const e = o.forwardRef((r, a) => /* @__PURE__ */ o.createElement(t, { ref: a, ...r, weights: n }));
e.displayName = "TagChevronIcon";
const s = e;
export {
  s as TagChevron,
  e as TagChevronIcon
};
